import React from "react";
import BackgroundSettings from "fantastic/components/common/controls/background/Settings";

export default ({
  onChange,
  node,
  onlyColor,
  scrollToIfNeeded,
  field = "css_background"
}) => {
  const params = {
    onChange,
    onlyColor: onlyColor,
    scrollToIfNeeded,
    color: { field: field, value: node[field] },
    image: {
      field: `${field}_image`,
      value: node[`${field}_image`]
    },
    repeat: {
      field: `${field}_repeat`,
      value: node[`${field}_repeat`]
    },
    position: {
      field: `${field}_position`,
      value: node[`${field}_position`]
    }
  };

  return <BackgroundSettings {...params} />;
};
